<template>
  <div class="testinomial">
    <div class="stars">
      <span class="star" v-for="i in stars" :key="i">
        <img src="@/assets/icons/ico-star.svg" alt="" />
      </span>
    </div>
    <h3 class="title">
      <slot name="testimonial-title"></slot>
    </h3>
    <p class="text">
      <slot name="testimonial-text"></slot>
    </p>
    <span class="date">
      <slot name="testimonial-date"></slot>
    </span>
    <h4 class="name">
      <slot name="testimonial-name"></slot>
    </h4>

    <!-- <span class="location">
      <i class="fas fa-map-marker-alt"></i>
      <slot name="testimonial-location"></slot>
    </span>-->
  </div>
</template>

<script>
export default {
  name: 'CardTestimonial',
  props: {
    stars: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.testinomial {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 350px;
  background-color: hsl(var(--clr-primary-100));
  padding: 32px;

  border-bottom: hsl(var(--clr-primary-500));
  border-radius: 10px;
  box-shadow: 6px 6px 8px -4px hsl(var(--clr-primary-500));

  .stars {
    margin-bottom: 12px;
    margin-right: 3.2px;
  }

  .star + .star {
    margin-left: 2px;
  }

  .title {
    line-height: 24px;
    text-align: center;
    font-family: var(--ff-roboto-sans);
    margin-bottom: 20px;
    color: hsl(var(--clr-primary-500));
    font-size: 16px;
  }

  .text {
    margin-bottom: 10px;
    line-height: 20px;
    font-size: 14px;
    color: hsl(var(--clr-primary-700));
  }

  .date {
    margin-bottom: 5px;
    color: hsl(var(--clr-primary-700));
    font-size: 12px;
  }

  .name {
    font-family: var(--ff-roboto-sans);
    font-size: 16px;
    color: hsl(var(--clr-primary-700));
  }
}

@media (max-width: 900px) {
  .testinomial {
    width: 80%;
    padding: 20px;

    .title {
      font-size: 16px;
      margin-bottom: 12px;
    }

    .text {
      font-size: 12px;
    }
  }
  .testinomial + .testinomial {
    margin-top: 20px;
  }
}

@media (max-width: 600px) {
  .testinomial {
    width: 90%;
    margin-top: 12px;
  }
}
</style>
